module.exports = __webpack_public_path__ + "img/small_truck_orange.0b883ca3.svg";